import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import "../App.css";
import { Container, Image } from "react-bootstrap";
import SunWestLogo from "../Images/42-Years-Of-Trust_Color 1.webp";
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu/index.js";

export default function Navheader(props) {
    const [navbar, setNavbar] = useState(false);

    const changebackground = () => {
        if (window.scrollY >= 9) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    window.addEventListener('scroll', changebackground);
    return (
        <>
            <Navbar
                collapseOnSelect
                expand="lg"
                fixed="top"
                bg="dark"
                variant="dark"
                className={navbar ? 'navbar active' : 'navbar'}
            > <Container>
                <Navbar.Brand>
                   
                <div className="d-flex">
                <div>
                    <a href='https://www.swmc.com/'
                        target="_blank" rel="noreferrer noopener"
                        title="https://www.swmc.com/">
                        <Image
                           src={process.env.REACT_APP_CDN_LINK + "swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"}
                            fluid
                            alt="Sun West Mortgage Logo"
                            className="img-fluid w-50 main_logo"
                             width= "707px"
                height= "178px"
                        />
                        <img
                           src={process.env.REACT_APP_CDN_LINK + "swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"}
                            className="sunWestLogowhite_main img-fluid"
                            alt="Sun West Logo"
                            loading="lazy"
                             width= "707px"
                height= "178px"
                        />
                    </a>
                    </div>
                               
                            </div>
                          
                </Navbar.Brand>
                <UserWayAccessibilityMenu color="black" width={40} height={40} />
                </Container>

            </Navbar>
        </>
    );
}
